import { useMemo } from "react";
import { useQuery, UseQueryResult } from "@tanstack/react-query";

const API_BASE_URL =
  process.env.REACT_APP_ENV === "production"
    ? "https://itpiapi.lancaster.ac.uk/occupancy"
    : "https://jedha.lancaster.ac.uk/deskoccupancyapi";

const HIDDEN_GEMS_ORG_ID = "08788d7b-7f85-452e-8608-8e192ed0891c";

export interface HiddenGemLocation {
  key: string;
  poiId: number;
  organisationKey: string;
  buildingId: string | null;
  buildingName: string;
  name: string;
  latitude: number | null;
  longitude: number | null;
  tags: string[];
  imageUrl: string | null;
  locationType: number;
  capacity: number;
}

export const useHiddenGemsLocations = () => {
  return useQuery<HiddenGemLocation[]>(
    ["GetHiddenGemsLocations"],
    async () => {
      const response = await fetch(
        `${API_BASE_URL}/api/organisations/${HIDDEN_GEMS_ORG_ID}/locations?showWithoutDesk=true`
      );
      if (!response.ok) throw new Error("Failed fetching hidden gems locations.");
      return response.json();
    }
  );
};

export const useHiddenGemsSearch = (query: string) => {
  const locations = useHiddenGemsLocations();

  const searchResults = useMemo(() => {
    return query.length > 0
      ? locations.data?.filter(
          (loc) =>
            loc.name.toLowerCase().includes(query.toLowerCase()) ||
            loc.tags.some((t) =>
              t.toLowerCase().includes(query.toLowerCase())
            )
        ) ?? []
      : [];
  }, [locations, query]);

  return { ...locations, data: searchResults } as UseQueryResult<HiddenGemLocation[]>;
};
